import { ReactNode } from 'react';
import { Avatar as PrimeAvatar } from 'primereact/avatar';
import clsx from 'clsx';

interface AvatarProps {
    userName: string;
    showDescription?: boolean;
    role?: string;
    large?: boolean;
    colorsReverted?: boolean;
    underline?: boolean;
}

export function Avatar({
    userName,
    role,
    large,
    showDescription,
    colorsReverted,
    underline,
}: AvatarProps): ReactNode {
    const initials = userName
        .split(' ')
        .map((name) => name.charAt(0))
        .slice(0, 2)
        .join('');

    const descriptionTemplate = (userName: string, role?: string) => {
        const userNameClassName = clsx(
            'guardian-avatar--username',
            underline ? 'guardian-avatar--username--underline' : '',
        );
        const userNameNode = (
            <div className={userNameClassName}>{userName}</div>
        );
        if (!role) {
            return userNameNode;
        }

        return (
            <div className="flex flex-column">
                {userNameNode}
                <div className="guardian-avatar--role">{role}</div>
            </div>
        );
    };

    const wrapperClassName = clsx(
        'flex align-items-center gap-2',
        colorsReverted ? 'guardian-avatar--reverted' : null,
        large ? 'guardian-avatar--large' : null,
    );

    return (
        <div className={wrapperClassName}>
            <PrimeAvatar
                className="guardian-avatar"
                label={initials}
                shape="circle"
                size={large ? 'large' : 'normal'}
            />
            {(showDescription || role) && descriptionTemplate(userName, role)}
        </div>
    );
}
